import { render, staticRenderFns } from "./MobilePortalShell.vue?vue&type=template&id=4dfeac59&scoped=true&"
import script from "./MobilePortalShell.vue?vue&type=script&lang=js&"
export * from "./MobilePortalShell.vue?vue&type=script&lang=js&"
import style0 from "./MobilePortalShell.vue?vue&type=style&index=0&id=4dfeac59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfeac59",
  null
  
)

export default component.exports